module.exports = __webpack_public_path__ + "img/revolucionCanina3.c50d5bba.jpg";